// @ts-strict-ignore
import { Flex, mediaQuery } from "@hubble/web";
import { FontWeight, HubbleBody } from "components/parts/Typography";
import Button from "components/parts/button";
import styled from "styled-components";
import { Colors } from "themes/color-palette";

export const HowToBuyPageContainer = styled.div`
  background:
    linear-gradient(0deg, #fff 0%, #fff 100%),
    linear-gradient(179deg, #26ddf9 0%, rgba(143, 0, 255, 0) 100%);
  text-align: center;
`;

export const HowToBuyPageContainerDarkSection = styled.div`
  background: ${Colors.black_secondary};
  padding: 40px 40px 100px;
`;

/* 

  HowToBuyBanner.tsx styles

*/
export const BannerContainer = styled.section`
  position: relative;
  width: 100%;
  margin-top: 0px;
  box-sizing: border-box;
  background:
    linear-gradient(0deg, #fff 0%, #fff 100%),
    linear-gradient(179deg, #26ddf9 0%, rgba(143, 0, 255, 0) 100%);
`;
export const BannerMeta = styled.div`
  width: 100%;
  height: 40px;
  background: ${Colors.gray[50]};
  padding: 6px 60px;
  box-sizing: border-box;
  margin-bottom: 56px;

  @media ${mediaQuery.tabletSmDown}, ${mediaQuery.desktopLgDown} {
    padding: 4px 24px;
    margin-bottom: 40px;
  }
`;

export const BannerMetaContentWrapper = styled(Flex)`
  margin: auto;
  width: 100%;
  height: 100%;

  @media ${mediaQuery.desktopLgUp} {
    width: 1200px;
  }
`;

export const BannerContent = styled.div`
  z-index: 33;
  position: relative;
`;

export const TokenBuyLinkBtn = styled(Button)`
  margin: 0 auto;
  font-size: 16px;
  font-weight: ${parseInt(FontWeight.bold600)};
`;

export const BannerCoinContainer = styled.div`
  position: relative;
  width: 678px;
  height: 678px;
  text-align: center;
  margin: 0 auto;
  margin-top: -125px;
  z-index: 0;

  @media (max-width: 767px) {
    height: auto;
    width: 100%;
    padding-bottom: 100%;
    margin-top: -90px;
    margin-bottom: 10px;
    img.buying-guide__banner-bg {
      position: absolute;
      height: auto;
      width: 100%;
      color: transparent;
    }
  }
`;

export const CoinImageContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border-radius: 100%;
  overflow: hidden;
  @media (max-width: 767px) {
    width: 76px;
    height: 76px;
  }
`;

export const FooterSectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  grid-template-rows: 1fr;
  gap: 75px;
  grid-template-areas: "footer-section__text footer-section__img";
  margin: -245px 1rem 0 5rem;
  position: relative;
  z-index: 2;

  & > div:first-child {
    grid-area: footer-section__text;
    align-self: end;
    margin-bottom: 60px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    grid-template-areas: "footer-section__text" "footer-section__img";
    margin-top: 60px;
    margin: -100px auto 0 auto;
    gap: 2rem;
  }
`;

export const FooterSectionImageContainer = styled.div`
  position: relative;
  height: 450px;
  grid-area: footer-section__img;
  aspect-ratio: 8/7;
  align-self: end;
  @media (max-width: 767px) {
    height: 275px;
    aspect-ratio: 7/6;
    right: -45px;
    justify-self: center;
  }
`;

export const PriceIndicatorContainer = styled(Flex)`
  gap: 1rem;
  margin: 1rem auto 1.5rem auto;
  flex-wrap: wrap;
`;

/* 

  BuyingSteps.tsx styles

*/

export const BuyingStepsContainer = styled.section`
  position: relative;
  width: 100%;
  margin-top: 0px;
  box-sizing: border-box;
  background: ${Colors.gray[50]};
  box-sizing: border-box;
  padding: 0 100px 40px;
  @media (max-width: 768px) {
    padding: 0 24px 40px;
  }
`;

export const BuyingStepsHeadingContainer = styled.div`
  margin: auto;
  max-width: 617px;
  padding-top: 112px;
  margin-bottom: 83px;

  @media (max-width: 768px) {
    padding-top: 46px;
    margin-bottom: 49px;
  }
`;

export const HowToBuyAccordionContainer = styled.div`
  margin: auto;
  max-width: 784px;
`;

export const StepTitleContainer = styled.div`
  text-align: left;
  flex: 1;
`;

export const StepDescription = styled(HubbleBody)`
  a > span {
    white-space: pre;
    text-underline-offset: 2px;
  }
  }
`;

export const QRContainer = styled.div`
  width: max-content;
  text-align: center;
  display: contents;
`;

export const StepIconContainer = styled(Flex)`
  border-radius: 100%;
  height: 24px;
  width: 24px;
  background: ${({ isDark }) =>
    isDark ? "transparent" : "rgba(1, 3, 4, 0.08)"};
  border: 1px solid
    ${({ isDark }) => (isDark ? "rgb(212, 200, 200)" : "transparent")};

  svg {
    height: 14px;
    width: 14px;
  }
`;

/* 

  Prices page redirection heading styles

*/

export const PricesPageRedirectContainer = styled.section`
  padding: 40px 0;
  background: ${({ isDark }) =>
    !isDark ? Colors.gray[50] : Colors.black_secondary};
  text-align: center;

  @media (max-width: 768px) {
    padding: 24px 0;
  }
`;

/* 

  LatestOnCoin.tsx styles

*/

export const LatestOnCoinContainer = styled.section`
  background: ${Colors.gray[50]};
  text-align: center;
  padding: 105px 36px;

  @media (max-width: 768px) {
    padding: 72px 36px;
  }

  h4 {
    text-align: left;
  }
`;

/* 

  TrendingTokens.tsx styles

*/

export const TrendingTokensContainer = styled.section`
  background: ${Colors.gray[50]};
  text-align: center;
  padding: 45px 36px 105px;

  .slick-dots.slick-thumb li {
    width: 10px;
    height: 10px;
    flex-shrink: 0;
    background: #d9d9d9;
    margin: 0 3px;
    border-radius: 999px;
    transition: all 0.5s ease-in-out;
  }

  .slick-dots.slick-thumb li.slick-active {
    background: black;
  }

  @media (max-width: 768px) {
    padding: 36px 28px 84px;
  }
`;

export const TrendingTokensSliderContainer = styled.div`
  padding: 10px;
  max-width: 848px;
  margin: auto;

  .slick-track .slick-slide {
    width: 128px;
    margin: 0 8px;
  }
`;
/* 

  OtherAssets.tsx styles

*/

export const OtherCryptoAssetsContainer = styled.section`
  text-align: center;
  padding: 105px 36px 60px;
  margin: auto;

  @media (max-width: 768px) {
    padding: 72px 0;
  }
`;

export const AssetListContainer = styled(Flex)`
  column-gap: 48px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 0px;
    flex-direction: column;
  }
`;

export const AssetListItem = styled(Flex)`
  gap: 16px;
  padding: 39px 1px;
  border-bottom: 1px solid #4d4f4f;
  width: 350px;
  max-width: 350px;

  img {
    border-radius: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: unset;
  }
`;

/* 

  OtherAssets.tsx styles

*/

export const HowToBuyFAQsContainer = styled.section`
  padding: 10px;
  max-width: 848px;
  margin: auto;

  text-align: left;
`;
